var $38ae0524671e48fd$exports = {};
$38ae0524671e48fd$exports = {
    "maximum": `Daugiausia`,
    "minimum": `Ma\u{17E}iausia`
};


export {$38ae0524671e48fd$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
